export default "__VITE_ASSET__Fgd_TJ8j__"